import React from "react";
import Navbar from "../navbar/Navbar";
import GelleryImg from "../../../Assets/gelleryBackIm.jpeg";
import pic1 from "../../../Assets/img_1.png";
import pic2 from "../../../Assets/img_2.png";
import pic3 from "../../../Assets/img_3.png";
import Footer from "../../footer/Footer";
import { Helmet } from "react-helmet-async";

const GalleryPage: React.FC = () => {
  const galleryImages = [
    { src: "https://puphub-customer.s3.ap-south-1.amazonaws.com/static_data/images/img_1.png", alt: "Happy dog playing in the park" },
    { src: "https://puphub-customer.s3.ap-south-1.amazonaws.com/static_data/images/img_2.png", alt: "Puppy receiving grooming service" },
    { src: "https://puphub-customer.s3.ap-south-1.amazonaws.com/static_data/images/img_3.png", alt: "Dog training session with owner" },
    { src: "https://puphub-customer.s3.ap-south-1.amazonaws.com/static_data/images/img_3.png", alt: "Group of dogs at daycare" },
    { src: "https://puphub-customer.s3.ap-south-1.amazonaws.com/static_data/images/img_2.png", alt: "Veterinary checkup in progress" },
    { src: "https://puphub-customer.s3.ap-south-1.amazonaws.com/static_data/images/img_1.png", alt: "Pet owner bonding with their dog" },
    { src: "https://puphub-customer.s3.ap-south-1.amazonaws.com/static_data/images/img_2.png", alt: "Dog enjoying a treat" },
    { src: "https://puphub-customer.s3.ap-south-1.amazonaws.com/static_data/images/img_3.png", alt: "Puppy socialization class" },
    { src: "https://puphub-customer.s3.ap-south-1.amazonaws.com/static_data/images/img_1.png", alt: "Professional dog grooming" }
  ];

  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://puphub.co.in/gallery" />
        <title>PupHub Partner | Gallery</title>
        <meta
          name="description"
          content="Explore the PupHub Partner gallery showcasing events and pets."
        />
      </Helmet>
      
      <Navbar />
      
      <div
        className="w-[100vw] h-[30vh] sm:h-[70vh] relative"
        style={{
          backgroundImage: `url(${GelleryImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        role="img"
        aria-label="Gallery background showing happy pets"
      />
      
      <div className="m-5">
        <p className="flex text-3xl text-white m-5 justify-center items-center font-DancingScript text-center">
          A collection of captivating images that tell a story
        </p>
        
        <section className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {galleryImages.map((image, index) => (
            <img
              key={`gallery-img-${index}`}
              className="rounded-2xl duration-300 hover:scale-105"
              src={image.src}
              alt={image.alt}
              loading="lazy"
            />
          ))}
        </section>
      </div>
      
      <Footer />
    </>
  );
};

export default GalleryPage;